<app-solution-step *ngFor="let step of solution.solutionSteps; let index = index" [Index]="index"></app-solution-step>
<div class="d-flex">
  <button (click)="AddStep()" class="btn btn-primary ms-auto">
    <i class="feather icon-plus ng-star-inserted"></i>
    <label class="mb-0 ms-1">{{'admin.solution.template.add_step' | translate}}</label>
  </button>
  <button [disabled]="!solution.solutionSteps.length || !isStepsValidate" class="btn btn-primary ms-2" (click) = "submitSolution()">
    {{'admin.solution.template.save' | translate}}
  </button>
</div>
